import React from "react";

function AnalyticsWorkspaceHero({ eyebrow, title, description, items = [] }) {
  return (
    <div className="card analytics-workspace__hero">
      <div className="card-body">
        <div className="analytics-workspace__hero-head">
          <div className="analytics-workspace__hero-copy">
            {eyebrow && <span className="analytics-workspace__eyebrow">{eyebrow}</span>}
            {title && <h2 className="analytics-workspace__title">{title}</h2>}
            {description && <p className="analytics-workspace__description">{description}</p>}
          </div>
        </div>

        {items.length > 0 && (
          <div className="row">
            {items.map((item) => (
              <div key={item.label} className="col-xl-3 col-md-6 mb-3">
                <div className="analytics-workspace__summary-card">
                  <span className="analytics-workspace__summary-label">{item.label}</span>
                  <strong className="analytics-workspace__summary-value">{item.value}</strong>
                  {item.hint && <small className="analytics-workspace__summary-hint">{item.hint}</small>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AnalyticsWorkspaceHero;
